export default {
    locales: ['de'],
    messages: {
        'place': 'Ort',
        'place-mobile': 'Ort : {rank}',
        'bib': 'Bib',
        'name': 'Name',
        'hometown': 'Heimatstadt',
        'bracket': 'Klammer',
        'pace': 'Tempo',
        'chip': 'Chip',
        'time': 'Zeit',
        'time-mobile': 'Zeit : {time}',
        'generated_at': 'Erzeugt {time}',
        'loading': 'Laden',
        'data-load-error': 'Sieht aus wie es ein Problem Laden von Daten.',
        'waiting-results': 'Warten auf Ergebnisse',
        'error': 'Fehler',
        'gender': 'Geschlecht'
    }
};



// WEBPACK FOOTER //
// ./translate/de.js